// Generated by ReScript, PLEASE EDIT WITH CARE


var Ref = {};

var Children = {};

var Context = {};

var Fragment = {};

var StrictMode = {};

var Suspense = {};

var SuspenseList = {};

var Experimental = {
  SuspenseList: SuspenseList
};

var Uncurried = {};

export {
  Ref ,
  Children ,
  Context ,
  Fragment ,
  StrictMode ,
  Suspense ,
  Experimental ,
  Uncurried ,
  
}
/* No side effect */
